import PropTypes from 'prop-types'

const InputWithDropdownFieldPropTypes = {
  dropdownOptions: PropTypes.array, // Dropdown.Item props array, see semantic-ui-react docs
  dropdownDefault: PropTypes.string, // Default dropdown value
  onDropdownChange: PropTypes.func, // Called onChange
}

// for masked input see also https://github.com/text-mask/text-mask/blob/master/componentDocumentation.md
const maskedInputPropTypes = {
  mask: PropTypes.oneOfType([PropTypes.array, PropTypes.func]), // input mask - see docs mentioned above
  guide: PropTypes.bool, // false to hide placeholder chars (like parens in phone number)
}

const commonPropTypes = {
  elmId: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  viewMode: PropTypes.bool, // display field in view mode.  Requires special view render
  breakAll: PropTypes.bool, // default: false.  When true, will word-break on all chars.
  helpContent: PropTypes.node, // tooltop content
  required: PropTypes.bool, // adds required UI but does not validate for required
  action: PropTypes.bool, // shortcut for button at end of input, see semantic-ui-react docs
  splitValue: PropTypes.func, // use to split API value into parts for special cases
  normalizeOnBlur: PropTypes.func, // allows to normalize inputs on blur event
  ...maskedInputPropTypes,
  ...InputWithDropdownFieldPropTypes,
}

export default commonPropTypes
